import uuid from 'react-native-uuid';

import { DEVICE_ID_KEY } from '@constants';

import { getStorageItem, setStorageItem } from './storage';

export const resetDeviceKey = () => {
  setStorageItem(DEVICE_ID_KEY, '');
  return getDeviceKey();
};

export const getDeviceKey = () => {
  let deviceId = getStorageItem(DEVICE_ID_KEY);

  if (!deviceId) {
    deviceId = uuid.v4();
    setStorageItem(DEVICE_ID_KEY, deviceId);
  }
  return deviceId;
};
